/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateUserProfileDto { 
    displayAgency?: string;
    position?: string;
    location?: string;
    language?: string;
    phone?: string;
    phoneMobile?: string;
}

